module.exports = __webpack_public_path__ + "static/media/How can you assign a document to a particular document type.175e3780.png";